// extracted by mini-css-extract-plugin
export default {"button":"Button_button__6d0Ru","riize":"Button_riize__g6s5y","aespa":"Button_aespa__suvxw"};